import ImageGallery from "react-image-gallery";

// A photo that cannot load (missing file, another bucket) is marked so it hides instead of showing the
// browser's broken-image mark on the viewer (the slider's own styles hide `img[data-failed]`).
const markFailed = (event) => {
  event.currentTarget.dataset.failed = "true";
};

const FeedImageSlider = ({ data, autoPlay, selectedIndex }) => {
  return (
    <div className="image-slider">
      <ImageGallery
        items={data}
        autoPlay={autoPlay ? autoPlay : false}
        showFullscreenButton={false}
        showPlayButton={false}
        slideInterval={3000}
        startIndex={selectedIndex}
        onImageError={markFailed}
        onThumbnailError={markFailed}
      />
    </div>
  );
};

export default FeedImageSlider;
